<section class="video-animation">
  <video class="video" [src]="data_general.video.url"
    playsinline="true" webkit-playsinline="true" preload="auto" muted="muted"></video>
</section>
